

<div class=" min-h-screen">
<app-shared-layout
        [Analysis]="title"
        [hideAdd]="false"
        (addItem)="onAdd()"
        [viewDetails]="viewDetails"
        [addPermission]="addPermission"
        [smallForm]="viewType !== 'view'"
        [secondaryWithStyle]="viewType !== 'view'"
        [animationSize]="viewType !== 'view' ? 'eighty' : 'full'"
        [formTitle]="viewDetailsTitle"
        (closeDetails)="closePanel()"
>
    <div ngProjectAs="primary-panel">
        <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedIndexChange)="selectEvent($event)">
            <mat-tab *ngFor="let tab of warehouseTabs; index as i" [label]="tab.warehouse">
                <app-paginated-data-table
                        [tableConfigurations]="tableConfiguration"
                        [tableList]="tab.users"
                        [actionButtons]="getActionButtons(tab)"
                        [permissions]="permissions"
                        (customAction)="customAction($event)"
                          [additionalVariables]="filter"
                >
                </app-paginated-data-table>
            </mat-tab>
        </mat-tab-group>
    </div>

    <div ngProjectAs="secondary-panel">
        <app-system-roles-view *ngIf="viewType === 'view'" (onClose)="closePanel()">
        </app-system-roles-view>
    </div>
</app-shared-layout>
</div>
